import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import {
  surveyDistributionOptionsArray,
  bareOrClientSendArray,
  smsOrEmailArray,
  mspPlatformArray,
} from './SharedConstants';

const b2cB2bArray = [
  { value: 'B2C', label: 'B2C' },
  { value: 'B2B', label: 'B2B' },
  { value: 'Other', label: 'Other' },
];

const genderOptionsArray = [
  { value: 'Any', label: 'Any' },
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'NonBinary', label: 'Non-binary' },
  { value: 'Other', label: 'Other' },
];

const customerSatisfactionPages = [
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.CustomerSatisfaction,
    fields: [
      {
        fieldName: 'DistributionOfSurvey',
        label: 'Distribution of Survey',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: surveyDistributionOptionsArray,
      },
      {
        fieldName: 'DistributionOfSurveyDetails',
        label: 'Please Describe',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.DistributionOfSurvey || !item.DistributionOfSurvey.includes('Other'),
      },
      {
        fieldName: 'BareOrClientSend',
        label: 'Does BARE send or does the Client send?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareOrClientSendArray.map((b) => b.label)),
      },
      {
        fieldName: 'SmsorEmailForBare',
        label: 'If BARE sends, SMS or Email?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(smsOrEmailArray.map((s) => s.label)),
        hide: (item) => item.BareOrClientSend !== 'BARE send',
      },
      {
        fieldName: 'FrequencyOfSurvey',
        label: 'Frequency of Survey?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TargetNumResponses',
        label: 'Target Number of Responses?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'IncentivesDescription',
        label: 'Incentives (please describe)?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'B2borB2c',
        label: 'B2C, B2B, or Other?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: b2cB2bArray,
      },
    ],
  },
  {
    label: 'Survey',
    hide: (item) => item.TypeCode != ServiceTypeEnum.CustomerSatisfaction,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CollaborationInDataSoftware',
        label: 'Will Collaboration be used in Data Software?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'RequiredLanguageCode',
        label: 'Required Language(s) reporting',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
    ],
  },
  {
    label: 'Target Audience',
    hide: (item) => item.TypeCode != ServiceTypeEnum.CustomerSatisfaction,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'OtherTargetAudienceRequirements',
        label: 'Other target audience requirements',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'MaritalStatusCode',
        label: 'Marital Status',
        className: 'col-12',
        type: InputTypesEnum.CommonMaritalStatusLookupItemSelect,
      },
    ],
  },
];

export default customerSatisfactionPages;
